import Slideout from 'slideout';
import videojs from 'video.js';
import 'videojs-mux';
import { debounce } from 'lodash';
import 'videojs-contrib-quality-levels';
import '@pm-connect/videojs-hls-quality-selector';
import PWA from "./pwa";

if (INSTALL_PWA) { // set in master.blade.php
    (async function () {
        await new PWA();
    })();
}

function videoScreenshotChangeHeight() {
    const videoScreenshots = $('.free-browsing-screenshot')
    if (videoScreenshots.length > 0 ) {
        const videoHeight = $('video').first().height();
        videoScreenshots.each(function() {
            $(this).css('max-height', videoHeight)
        })
    }
}

/**
 * Check if video is a live stream
 * @param {HTMLVideoElement} video
 * @return {boolean}
 */
function isLiveStream(video) {
    return video.classList.contains('video-stream');
}

const {
    host, hostname, href, origin, pathname, port, protocol, search
} = window.location

const autoplayEventName = "Autoplayed-Video";

require.ensure(["jquery"], function(jquery) {
    /**
     * Initialise a VideoJS player
     * @param {HTMLVideoElement} video
     * @param {number} playerInitTime
     * @return {Player}
     */
    function initVideo(video, playerInitTime) {
        return videojs(video, {
            html5: {
                hls: {overrideNative: true},
                NativeAudioTracks: false,
                NativeVideoTracks: false,
            },
            techOrder: ['html5'], // additional technologies can be added here
            controls: true,
            controlBar: {
                pictureInPictureToggle: false,
            },
            aspectRatio: "16:9",
            fluid: true,
            plugins: {
                mux: {
                    debug: false,
                    data: {
                        env_key: window.MUX_ENV_KEY, // required
                        // Metadata
                        player_init_time: playerInitTime, // ex: 1451606400000
                        video_title: video.getAttribute('data-name')
                    }
                }
            }
        });
    }

    /**
     * Set the quality of the video and update selected quality in the menu
     * @param hls
     * @param {number|string} quality
     */
    function setHlsQuality(hls, quality) {
        // Set selected menu item to the new quality level
        Array.prototype.forEach.call(document.getElementsByClassName('vjs-menu-item'), item => {
            item.classList.toggle('vjs-selected', item.innerText.includes(quality))
        });

        // Set the Quality of the stream
        hls.setQuality(quality);
    }

    /**
     * Get selected video quality and update the player
     * @param {HlsQualitySelectorPlugin} hls
     * @param {QualityLevelList} levels
     * @param {number|string|null} userLevel
     */
    function updateVideoQuality(hls, levels, userLevel) {
        // set userLevel to the default value if available
        if (userLevel === null && DEFAULT_VIDEO_QUALITY !== undefined) {
            userLevel = DEFAULT_VIDEO_QUALITY;
        }

        // quality level already selected by the user
        if (levels[levels.selectedIndex] || userLevel !== null) {
            const userLevelIncluded = getQualityLevel(levels, userLevel);

            if (userLevelIncluded[0] || userLevel === "auto") {
                setHlsQuality(hls, userLevel);
            }
        } else {
            const defaultVideoQuality = getQualityLevel(levels, DEFAULT_VIDEO_QUALITY || '');

            if (DEFAULT_VIDEO_QUALITY === undefined || DEFAULT_VIDEO_QUALITY === 'auto' || defaultVideoQuality.length < 1) {
                setHlsQuality(hls, 'auto');
            } else {
                setHlsQuality(hls, defaultVideoQuality[0].height);
            }
        }
    }

    /**
     * Search the quality levels list to get the matching quality levels
     * @param {QualityLevelList} levels
     * @param {number|string} quality
     * @return {QualityLevel[]}
     */
    function getQualityLevel(levels, quality) {
        if (isNaN(quality)) {
            return [];
        }

        const match = levels['levels_'].filter(data => (data.height === quality));

        if (match.length > 0) {
            return match;
        }

        // find the 2nd closest match
        return levels['levels_'].reduce(
            (previous, current) => Math.abs(current.height - quality) < Math.abs(previous.height - quality)
                ? current
                : previous
        );
    }

    let hlsVideosExist = false;
    $(function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        let page = 2;
        let lastMediaItem;

        const updateLastMediaItem = () => {
            lastMediaItem = document.querySelector('.media-item:last-child');
        };
        updateLastMediaItem();

        const onScroll = debounce(checkScroll, 500);

        const mediaElm = document.querySelector('#scrolling');
        if (mediaElm && lastMediaItem) {
            mediaElm.addEventListener('scroll', onScroll);
        }

        function getVideos(uri, page) {
            $.get({
                url: `/api/videos${uri}/${page}`,
                type: 'GET',
            }).done(function (data) {
                if (data === '') {
                    mediaElm.removeEventListener("scroll", onScroll);
                    return;
                }

                $("#scrolling").append(data);

                const videos = document.querySelectorAll('.videos-to-process');

                for (let i = 0,  j = videos.length; i < j; i++) {
                    const video = videos[i];
                    video.classList.remove('videos-to-process');

                    initVideo(video, playerInitTime);
                }

                updateLastMediaItem();
            });
        }

        function checkScroll() {
            if (lastMediaItem.getBoundingClientRect().top <= mediaElm.clientHeight) {
                // remove last item of array if it is a number
                let items = pathname.split("/");
                if (items.length && Number.isInteger(+items[items.length - 1])) {
                    items.pop();
                }
                getVideos(items.join("/"), page++);
            }
        }

        // -------------------------------------------------------- VIDEO.JS
        let userLevel = null;
        var videos = document.getElementsByClassName('video-js');
        const playerInitTime = Date.now();
        var streamUrl = null;
        for (let i = videos.length - 1; i >= 0; i--) {
            const video = videos[i];
            video.classList.remove('videos-to-process');
            const autoplayVideo = video.classList.contains('video-autoplay');
            const isStream = video.classList.contains('video-stream');
            const vidJs = initVideo(video, playerInitTime);
            var stream = $('#'+ videos[i].id + ' .streams');
            if (stream[0]) {
                streamUrl = stream[0].src;
                hlsVideosExist = true;
            }
            var player = videojs(videos[i]);
            if (freeBrowsing === false && hlsVideosExist === true) {
                player.hlsQualitySelector();
                player.src(streamUrl);
            }

            streamUrl = null;

            // autoplay the first video
            if (autoplayVideo) {
                vidJs.ready(function() {
                    // Delaying autoplay by 1 second after the video is ready, otherwise it won't work.
                    _.delay(function () {
                        const promise = vidJs.play();

                        if (promise !== undefined) {
                            promise.then(function() {
                                // Video played without muting
                                fireAutoplayEvent(false, isStream);
                            }).catch(function(error) {
                                // Attempt to mute and then play the video
                                video.muted = true;
                                const secondPromise = vidJs.play();
                                if (secondPromise !== undefined) {
                                    secondPromise.then(function() {
                                        // Video played with muting
                                        fireAutoplayEvent(true)
                                    })
                                }
                            });
                        }
                    }, 1000);

                    // Create & Fire autoplay event
                    function fireAutoplayEvent(muted = false, isLiveStream = false) {
                        const videoData = video.getAttribute('data-action_data');
                        const videoTarget = video.getAttribute('data-action_target');
                        const autoplayEvent = new CustomEvent(autoplayEventName, {
                            detail: {
                                "target": videoData,
                                "data": videoTarget,
                                "muted": muted,
                                "isLiveStream": isLiveStream
                            }
                        });
                        document.dispatchEvent(autoplayEvent);
                    }
                });
            }
        }

        if (typeof unParsedUserLevel !== "undefined" && !freeBrowsing && hlsVideosExist) {
            //Set User Video Quality Level from String
            if (unParsedUserLevel !== "auto") {
                userLevel = parseInt(unParsedUserLevel, 10);
            } else {
                userLevel = unParsedUserLevel;
            }
        }

        if (!freeBrowsing && hlsVideosExist) {
            // Change users video quality settings when event emitted
            window.addEventListener("videoQualityChanged", function (e) {
                userLevel = e.detail;
                $.post('/settings/video-quality', {video_quality: userLevel.toString()});
                // Track change of quality
                PMCMixpanel.track(PMCMixpanel.triggeredAction, {
                    'action_type': e.detail.isLiveStream
                        ? PMCMixpanel.triggeredActionEvents.STREAM_QUALITY_CHANGED
                        : PMCMixpanel.triggeredActionEvents.VIDEO_QUALITY_CHANGED,
                    'action_target': e.target,
                    'action_data': e.detail,
                });
            });
        }

        $(window).on('load', function () {
            const videos = $('video');

            // When hls video is played set user quality
            videos.on('play', function (event) {
                if (hlsVideosExist === true) {
                    const player = videojs(event.target.id);
                    const levels = player.qualityLevels();
                    const hls = player.hlsQualitySelector;

                    setTimeout(() => {
                        updateVideoQuality(hls, levels, userLevel);
                    }, 1000);
                }
            });

            if (hlsVideosExist) {
                //Changes the Quality label on video quality Settings to translation
                videos.on('loadedmetadata', function () {
                    var menuTitle = document.getElementsByClassName('quality-title');
                    for (const title of menuTitle) {
                        title.innerText = videoQualityTranslation;
                    }
                });
            }

            // -------------------------------------------------------- MIXPANEL EVENTS

            // TODO: check class for live stream, fix type hints
            // Add event listener for autoplay event
            document.addEventListener(autoplayEventName, function(e) {
                console.log('sending mixpanel autoplay event')
                PMCMixpanel.track(PMCMixpanel.triggeredAction, {
                    'action_type': e.detail.isLiveStream
                        ? PMCMixpanel.triggeredActionEvents.STREAM_AUTOPLAYED
                        : PMCMixpanel.triggeredActionEvents.VIDEO_AUTOPLAYED,
                    'action_target' : e.detail.target,
                    'action_data' : e.detail.data,
                    'muted_video' : e.detail.muted
                });
            });

            videos.on('play', function () {
                PMCMixpanel.track(PMCMixpanel.triggeredAction, {
                    'action_type': isLiveStream(this)
                        ? PMCMixpanel.triggeredActionEvents.STREAM_PLAYED
                        : PMCMixpanel.triggeredActionEvents.VIDEO_PLAYED,
                    'action_target': $(this).data('action_target'),
                    'action_data': $(this).data('action_data'),
                });
            }).on('pause', function () {
                PMCMixpanel.track(PMCMixpanel.triggeredAction, {
                    'action_type': isLiveStream(this)
                        ? PMCMixpanel.triggeredActionEvents.STREAM_PAUSED
                        : PMCMixpanel.triggeredActionEvents.VIDEO_PAUSED,
                    'action_target': $(this).data('action_target'),
                    'action_data': $(this).data('action_data'),
                });
            }).on('seeked', function () {
                PMCMixpanel.track(PMCMixpanel.triggeredAction, {
                    'action_type': isLiveStream(this)
                        ? PMCMixpanel.triggeredActionEvents.STREAM_SEARCHED
                        : PMCMixpanel.triggeredActionEvents.VIDEO_SEARCHED,
                    'action_target': $(this).data('action_target'),
                    'action_data': $(this).data('action_data'),
                });
            }).on('volumechange', debounce(volChange, 250));

            function volChange() {
                PMCMixpanel.track(PMCMixpanel.triggeredAction, {
                    'action_type': isLiveStream(this)
                        ? PMCMixpanel.triggeredActionEvents.STREAM_VOLUME_CHANGED
                        : PMCMixpanel.triggeredActionEvents.VIDEO_VOLUME_CHANGED,
                    'action_target': $(this).data('action_target'),
                    'action_data': $(this).data('action_data'),
                });
            }

            $('.video-js').on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function () {
                PMCMixpanel.track(PMCMixpanel.triggeredAction, {
                    'action_type': isLiveStream(this)
                        ? PMCMixpanel.triggeredActionEvents.STREAM_FULL_SCREEN
                        : PMCMixpanel.triggeredActionEvents.VIDEO_FULL_SCREEN,
                    'action_target': $(this).data('action_target'),
                    'action_data': $(this).data('action_data'),
                });
            });

            videoScreenshotChangeHeight()
        });

        // -------------------------------------------------------- HEADER CHANGES ON SCROLL
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('header.main').outerHeight();

        $(window).scroll(function(){
            minimiseMatchScoreboardFixturesBar($(this).scrollTop());
            didScroll = true;
        });

        // -------------------------------------------------------- FIXED MATCH SCOREBOARD FOR 2 TEAMS FIXTURE BAR
        function minimiseMatchScoreboardFixturesBar(topPos) {
            if (topPos > 120) {
                $('.scoreboard').css('height', '60px');
                $('.scoreboard .club img').css({'width': '40px', 'height': '40px'});
                $('.scoreboard .counters span.main').css({'font-size': '18px', 'background': 'none'});
                $('.scoreboard .club span').css('display', 'none');
                $('.scoreboard .counters').css('padding-top', '0');
                $('.scoreboard .counters span.sub').css('display', 'none');
            }
            else {
                $('.scoreboard').css('height', '');
                $('.scoreboard .club img').css({'width': '60px', 'height': '65px'});
                $('.scoreboard .counters span.main').css({'font-size': '24px', 'background': '#212c42'});
                $('.scoreboard .club span').css('display', 'block');
                $('.scoreboard .counters').css('padding-top', '10px');
                $('.scoreboard .counters span.sub').css('display', 'block');
            }
        }

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(this).scrollTop();
            if(Math.abs(lastScrollTop - st) <= delta)
                return;
            if (st > lastScrollTop && st > navbarHeight){
                $('header.main').removeClass('nav-down').addClass('nav-up');
            } else {
                if(st + $(window).height() < $(document).height()) {
                    $('header.main').removeClass('nav-up').addClass('nav-down');
                }
            }
            lastScrollTop = st;
        }

        // -------------------------------------------------------- SLIDEOUT MENU
        const rtl = document.querySelector('.rtl');
        let padding = 260;
        if (rtl) {
            padding = -260;
        }

        if(document.getElementById('menu')) {
            const slideout = new Slideout({
                'panel': document.getElementById('panel'),
                'menu': document.getElementById('menu'),
                'padding': padding,
                'tolerance': 70,
                'touch': false
            });

            // Toggle button
            $('.toggle').click(function() {
                slideout.toggle();
                return false;
            });

            slideout.on('beforeopen', function() {
                $('.fixed').addClass('fixed-open');
            });

            slideout.on('beforeclose', function() {
                $('.fixed').removeClass('fixed-open');
            });
        }

        // -------------------------------------------------------- SCROLL SUB MENU TO ACTIVE LINK
        if ($('nav.sub').length) {
            const window_width = $(window).innerWidth();
            const window_width_halved = window_width / 2;
            const current = $('nav.sub .active').position();
            const current_size = $('nav.sub .active').innerWidth();
            const current_size_halved = current_size / 2;
            const current_left = current.left;
            if(rtl) {
                const current_left_adjusted = window_width + window_width_halved;
                const final_position = current_left_adjusted + current_size_halved;
                if (current_left < window_width_halved) {
                    $('nav.sub ul').animate({
                        scrollLeft: final_position * -1
                    });
                }
            } else {
                const current_left_adjusted = current_left - window_width_halved;
                const final_position = current_left_adjusted + current_size_halved;
                if (current_left > window_width_halved) {
                    $('nav.sub ul').animate({
                        scrollLeft: final_position
                    });
                }
            }
        }

        // -------------------------------------------------------- MAIN MENU ACCORDION
        $('li.drop > a').click(function(){
            $(this).next('ul').slideToggle();
            $(this).parent('li').toggleClass('open');
            return false;
        });

        // -------------------------------------------------------- TOGGLE MEDIA SAVE
        $(document).on('click', 'a.save', function () {
            const route = this.getAttribute('data-route');

            if (this.getAttribute('data-video_id') !== "" && route !== "") {
                $.post(route);
            }

            this.classList.toggle('saved');

            return false;
        });

        // -------------------------------------------------------- TOGLE CONTEXT MENU
        $('a.context').click(function(){
            $('nav.context').show().delay(150).queue(function(){
                $('nav.context ul').slideToggle();
            }).dequeue();
            return false;
        });

        $('nav.context .mask').click(function(){
            $('nav.context').hide();
            $('nav.context ul').slideToggle();
            return false;
        });

        // -------------------------------------------------------- TOGGLE MODAL ON FIXTURES
        $('.fixtures a.alert').click(function(){
            $('#modal.fixtures').show();
            return false;
        });

        // -------------------------------------------------------- TOGGLE MODAL ON CLUBS
        $('.clubs a.alert').click(function(){
            $('#modal.clubs').show();
            return false;
        });

        // -------------------------------------------------------- CLOSING THE MODAL
        $('#modal .mask, #modal .modal-title a, #modal input[type=submit]').click(function(){
            $('#modal').hide();
            return false;
        });

        // -------------------------------------------------------- SWITCH TEAM ON LINE-UP PAGE
        $('.tabs a').click(function(){
            var current = $(this).attr('href');
            $('.tab').hide();
            $('.tab' + current).show();
            $('a.active').removeAttr('class');
            $(this).addClass('active');
            return false;
        });

        // -------------------------------------------------------- SCROLL PAGE TO CURRENT FIXTURE
        if ($('.fixtures #current').length) {
            var header_height = $('header.main').innerHeight();
            var sub_height = $('nav.sub').innerHeight();
            var scroll_dist = $('#current').offset().top;
            $('#scroll').scrollTop(scroll_dist - (header_height + sub_height));
        }

        if ($('.clubs #current').length) {
            var jumbotron_height = $('#jumbotron').innerHeight();
            var club_sub_height = $('nav.sub').innerHeight();
            var club_scroll_dist = $('#current').offset().top;
            $('#scroll').scrollTop(club_scroll_dist - (jumbotron_height + club_sub_height));
        }

        // -------------------------------------------------------- Auto-submit league selector
        $('#tournamentSelector').on('change', function () {
            this.form.submit();
        });
    });

    $(window).resize(function(){

        // -------------------------------------------------------- GET WINDOW DIMENSIONS
        var w_width = $(window).innerWidth();
        var w_height = $(window).innerHeight();

        // -------------------------------------------------------- RESIZE MAIN PANEL TO WINDOW HEIGHT
        $('#panel').css('min-height', w_height);

        // -------------------------------------------------------- FIXTURE SIZES (REQUIRES JQUERY.ACTUAL.MIN.JS)
        $('ul.fixtures').each(function (i, item) {
            var fixture_width = $(this).find('li.fixture a').actual('innerWidth');
            var fixture_display_width = $(this).find('li.fixture a .display').actual('innerWidth');
            var fixture_label_space = fixture_width - fixture_display_width;
            var fixture_label_width = fixture_label_space / 2;
            var fixture_label_icon_width = $(this).find('li.fixture a .club-badge').actual('innerWidth');
            var fixture_label_club_name = fixture_label_width - fixture_label_icon_width;
            var fixture_label_club_name_final = fixture_label_club_name - 24;
            $(this).find('li.fixture a .club').css('width', fixture_label_width);
            $(this).find('li.fixture a .club .club-name').css('width', fixture_label_club_name_final);
            $('.fixture-wrap li.fixture a .club .club-name').css('width', fixture_label_club_name_final);
        });

        // -------------------------------------------------------- MEDIA DETAIL SIZES
        var details_width = w_width - 135;
        $('.media-item .details').css('width', details_width);

        // -------------------------------------------------------- TICKER SIZES
        var ticker_width = $('.ticker li').innerWidth();
        var icon_width = $('.ticker li .icon').innerWidth();
        var time_width = $('.ticker li .time').innerWidth();
        var total_width = icon_width + time_width;
        var final_width = ticker_width - total_width;
        $('.ticker li .entry').css('width', final_width);

        // -------------------------------------------------------- MEDIA DETAIL SIZES
        var bar_width = $('.row-top').innerWidth();
        var value_width = $('.row-top .value').innerWidth();
        var value_total = value_width + value_width;
        var label_width = bar_width - value_total;
        $('.row .label').css('width', label_width);

        // -------------------------------------------------------- SET SCROLL PANEL SIZE ON NO-SCROLL PAGES
        var header_height = $('header.main').innerHeight();
        var jumbo_height = $('#jumbotron').innerHeight();
        var sub_height = $('nav.sub').innerHeight();
        var content_height = w_height - (header_height + sub_height);
        var content_height_jumbo = w_height - (jumbo_height + sub_height);
        $('.fixtures #scroll').css('height', content_height);
        $('.clubs #scroll').css('height', content_height_jumbo);

        videoScreenshotChangeHeight()
    }).resize();
});
